import * as React from 'react';

const TailwindLayout = ({ children }: { children: React.ReactNode }) => {
	React.useEffect(() => {
		document.getElementsByTagName('html')[0]?.classList.add('tailwind-font-reset');
		return () => document.getElementsByTagName('html')[0]?.classList.remove('tailwind-font-reset');
	}, []);

	return (
		<section style={{ fontSize: 'initial', overflow: 'scroll', width: '100%', height: '100%' }}>
			{children || null}
		</section>
	);
};

export default React.memo(TailwindLayout);
